import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide13ProjectSales.css';

const steps = [
  {
    id: '01',
    title: 'Consultation',
    desc: 'Understanding operational and technical requirements.',
  },
  {
    id: '02',
    title: 'Solution Design',
    desc: 'Engineering-driven system architecture tailored to each vessel.',
  },
  {
    id: '03',
    title: 'Project Planning',
    desc: 'Defining scope, timelines, documentation, and compliance needs.',
  },
  {
    id: '04',
    title: 'Execution Support',
    desc: 'Coordinating engineering teams, suppliers, and shipyards.',
  },
  {
    id: '05',
    title: 'Delivery & Integration',
    desc: 'Ensuring seamless implementation and operational readiness.',
  },
];

function Slide13ProjectSales() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 18 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-project-sales">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="project-sales-bg">
        <div className="project-sales-grid" />
        <div className="project-sales-glow project-sales-glow-left" />
        <div className="project-sales-glow project-sales-glow-right" />
        <div className="project-sales-noise" />
      </div>

      <img
        className="project-sales-ship"
        src="/images/project-sales/ship-network.png"
        alt=""
        aria-hidden="true"
      />

      <div className="project-sales-content">
        <motion.div className="project-sales-header" {...fadeUp(0.05)}>
          <h1>Project and Sales Department</h1>
          <p>
            The Project Sales team transforms operational requirements into engineered solutions, guiding each project
            from concept through execution with precision and technical expertise.
          </p>
        </motion.div>

        <motion.div className="project-sales-timeline" {...fadeUp(0.12)}>
          <div className="timeline-label">FROM CONCEPT TO COMMISSIONING</div>
          <div className="timeline-line" />
          <div className="timeline-steps">
            {steps.map((step) => (
              <div key={step.id} className="timeline-step">
                <div className="timeline-dot" />
                <div className="timeline-id">{step.id}</div>
                <div className="timeline-title">{step.title.toUpperCase()}</div>
                <div className="timeline-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </motion.div>

        <div className="project-sales-lower">
          <motion.div className="project-sales-lower-text" {...fadeUp(0.2)}>
            <div className="lower-label">SHIP DESIGN &amp; NEWBUILDING</div>
            <p>
              With combined knowledge and experience in design, engineering, project management, construction,
              installation, and commissioning, we deliver innovative designs and sustainable solutions while meeting
              IMO regulations.
            </p>
          </motion.div>

          <motion.div className="project-sales-cards" {...fadeUp(0.25)}>
            <div className="project-card">
              <div className="project-card-label">TOTAL TEAM</div>
              <div className="project-card-value">37</div>
            </div>
            <div className="project-card">
              <div className="project-card-label">DESIGN TEAM</div>
              <div className="project-card-value">4</div>
            </div>
            <div className="project-card">
              <div className="project-card-label">Sales Team</div>
              <div className="project-card-value">13</div>
            </div>
            <div className="project-card">
              <div className="project-card-label">Project Management Team</div>
              <div className="project-card-value">20</div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Slide13ProjectSales;
